import styled from 'styled-components';
import Toasts from './components/Toasts/Toasts';
import responsive from '../../../style/mixins/responsive';

interface WrapperProps {
  $topPosition: string;
}

export const StyledToasts = styled(Toasts)(({ theme: { size } }) => ({
  width: size.units(40),
}));

export const Wrapper = styled.div<WrapperProps>(({ theme: { size }, $topPosition }) => ({
  [StyledToasts]: {
    position: 'fixed',
    top: $topPosition,
    right: size.units(2),
    zIndex: 999999,
    overflow: 'visible',

    ...responsive.xs.downward({
      left: '50%',
      top: size.units(3),
      transform: 'translateX(-50%)',
    }),
  },
}));
